// extracted by mini-css-extract-plugin
export default {"tables":"Tables_tables__i8bac"};